"use strict";
var __decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
var __metadata = (this && this.__metadata) || function (k, v) {
    if (typeof Reflect === "object" && typeof Reflect.metadata === "function") return Reflect.metadata(k, v);
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.SearchCustomPipe = void 0;
//ANGULAR2 BITS
const core_1 = require("@angular/core");
const common_1 = require("@angular/common");
let SearchCustomPipe = class SearchCustomPipe {
    constructor(_datePipe, _decimalPipe) {
        this._datePipe = _datePipe;
        this._decimalPipe = _decimalPipe;
    }
    transform(value, term, keys) {
        if (value) {
            if (term) {
                if (keys && keys.length > 0) {
                    let ret = value.filter(item => {
                        for (let k in keys) {
                            if (keys[k] == 'updatedAt' || keys[k] == 'datehour') {
                                if (typeof item[keys[k]] != "undefined" && (this._datePipe.transform(item[keys[k]], 'medium').toLowerCase()).indexOf(term.toLowerCase()) > -1) {
                                    return true;
                                }
                            }
                            else {
                                if (typeof item[keys[k]] == "boolean") {
                                    term = JSON.parse(term);
                                    return item[keys[k]] == term;
                                }
                                if (typeof item[keys[k]] != "undefined" && (JSON.stringify((item[keys[k]])).toLowerCase().indexOf(term.toLowerCase()) > -1)) {
                                    return true;
                                }
                            }
                        }
                        return false;
                    });
                    return ret;
                }
                return value;
            }
            else {
                return value;
            }
        }
    }
};
exports.SearchCustomPipe = SearchCustomPipe;
exports.SearchCustomPipe = SearchCustomPipe = __decorate([
    (0, core_1.Pipe)({ name: 'searchCustom', pure: false }),
    __metadata("design:paramtypes", [common_1.DatePipe,
        common_1.DecimalPipe])
], SearchCustomPipe);
//# sourceMappingURL=search-custom.pipe.js.map